import * as d3 from 'd3';
import {wrap} from "@/utils/d3Utils.js"

export default function Legend(d, options) {
    const li = {
        w: 75, h: 30, s: 3
    };

    if ('undefined' !== typeof options)
        for (let i in options) if (options.hasOwnProperty(i) && 'undefined' !== typeof options[i])
            li[i] = options[i];

    let itemMouseClickListeners = [];

    this.addItemMouseClickListener = (listener) => {
        itemMouseClickListeners.push(listener);
    };

    d3.select(options.container).select("*").remove();


    const legend = d3.select(options.container).append("svg:svg")
        .attr("width", li.w)
        .attr("height", d.length * (li.h + li.s));

    const g = legend.selectAll("g")
        .data(d)
        .enter().append("svg:g")
        .attr("transform", (d, i) => "translate(0," + i * (li.h + li.s) + ")");

    const r = Math.min(li.w, li.h) * 0.2;

    g.append("svg:rect")
        .attr("rx", r)
        .attr("ry", r)
        .attr("width", li.w)
        .attr("height", li.h)
        .style("fill", d => d.color)
        .style("cursor", "pointer")
        .on("click", d => {
            for (let listener of itemMouseClickListeners) listener(d);
        });

    g.append("svg:text")
        .attr("x", li.w / 2)
        .attr("y", li.h / 2)
        .attr("dy", "0.35em")
        .style('fill', 'white')
        .style('font-size', '200')
        .attr("text-anchor", "middle")
        .text(d => d.label).call(wrap, li.w * 0.8, li.h * 0.8)
        .style("cursor", "pointer")
        .on("click", d => {
            for (let listener of itemMouseClickListeners) listener(d);
        });
}